/**
 * 错误模型定义
 * 定义应用中统一的错误类型和结构
 *
 * 核心内容：
 * 1. 错误类型枚举，分类应用中可能出现的错误
 * 2. 错误接口定义，统一错误数据结构
 * 3. 错误上下文和元数据接口
 */
/**
 * 应用错误类型枚举
 * 分类应用中可能出现的各种错误
 */
export var ErrorType;
(function (ErrorType) {
    // 网络相关错误
    ErrorType["NETWORK"] = "network";
    ErrorType["API"] = "api";
    ErrorType["TIMEOUT"] = "timeout";
    // 数据相关错误
    ErrorType["DATABASE"] = "database";
    ErrorType["STORAGE"] = "storage";
    ErrorType["VALIDATION"] = "validation";
    // 翻译相关错误
    ErrorType["TRANSLATION"] = "translation";
    ErrorType["TRANSLATION_API"] = "translation_api";
    ErrorType["TRANSLATION_UNAVAILABLE"] = "translation_unavailable";
    // 文档相关错误
    ErrorType["DOCUMENT"] = "document";
    ErrorType["DOCUMENT_NOT_FOUND"] = "document_not_found";
    ErrorType["DOCUMENT_PARSING"] = "document_parsing";
    // 用户相关错误（为后续功能准备）
    ErrorType["AUTH"] = "auth";
    ErrorType["PERMISSION"] = "permission";
    ErrorType["USER"] = "user";
    // UI 相关错误
    ErrorType["UI_RENDER"] = "ui_render";
    // 通用错误
    ErrorType["UNEXPECTED"] = "unexpected";
    ErrorType["NOT_IMPLEMENTED"] = "not_implemented";
    ErrorType["INVALID_OPERATION"] = "invalid_operation";
})(ErrorType || (ErrorType = {}));
/**
 * 错误严重性枚举
 * 描述错误的严重程度
 */
export var ErrorSeverity;
(function (ErrorSeverity) {
    ErrorSeverity["LOW"] = "low";
    ErrorSeverity["MEDIUM"] = "medium";
    ErrorSeverity["HIGH"] = "high";
    ErrorSeverity["CRITICAL"] = "critical";
})(ErrorSeverity || (ErrorSeverity = {}));
//# sourceMappingURL=error.model.js.map